'use client';

import classnames from 'classnames/bind';
import { XmarkOctagon2pxIcon } from '@dpa/react-icons';
import { RtText } from '@dpa/react-text';
import { RtButton } from '@dpa/react-buttons';
import React from 'react';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { useRouter } from '@/i18n/navigation';
import { getCategoriesRoute, TMultiPageRouteParams } from '@/_constants/routes';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Error-boundary';

type TProps = {
  onClick?: () => void;
};

export const ErrorBoundary = ({ onClick }: TProps) => {
  const translations = useTranslations('page-error-boundary');
  const router = useRouter();
  const params = useParams<TMultiPageRouteParams>();

  const categoryPath = getCategoriesRoute({ country: params.country });
  const handleClick = () => {
    router.replace(categoryPath);
    if (onClick) {
      onClick();
    }
  };

  const title = translations('title');
  const description = translations('description');
  const buttonText = translations('buttonText');

  return (
    <div className={cn(BLOCK_NAME)}>
      <XmarkOctagon2pxIcon size="lg" />
      <div className={cn(`${BLOCK_NAME}__text`)}>
        <RtText specification="main" typography="body-md-medium">
          {title}
        </RtText>
        <div className={cn(`${BLOCK_NAME}__description`)}>
          <RtText specification="variant" typography="body-sm-regular">
            {description}
          </RtText>
        </div>
      </div>
      <RtButton
        onClick={handleClick}
        label={buttonText}
        use="foggy"
        size="md"
      />
    </div>
  );
};
